export const NO_DISTINGUISHED_STATE_ERROR =
  'There should always be at least one distinguished column per parent. Set the last state of another column to 100% to define a new distinguished column, then you can edit the existing one.'

export const ERROR_IN_THE_RELEASED_NETWORK =
  'Network contains errors that need to be fixed before it can be released. Please check the downloaded file for more information.'

export const ASSUMPTION_SET_UNIQUE_VIOLATION_ERROR =
  'AssumptionSet with this name already exists.'

export const NETWORK_NAME_UNIQUE_VIOLATION_ERROR =
  'This network name already exists.'
